/**
 * Created by r4zi4l on 25.02.2021
 */

const Map2dAdviceBuildLogic = function (options) {
    Map2dAdviceBaseLogic.call(this, options);
};

Map2dAdviceBuildLogic.prototype = Object.create(Map2dAdviceBaseLogic.prototype);
Map2dAdviceBuildLogic.prototype.constructor = Map2dAdviceBuildLogic;

Map2dAdviceBuildLogic.prototype.findMove = function () {
    const unit = this.listAvailableUnits().filter((unit) => !Buildable.IsBuilt(unit) && !Map2d.currentMap.workers.findAssigned(unit) && Map2d.currentMap.workers.countRegularFree() > 0)[0];

    if (unit) {
        const infoOpen = InfoView.IsDisplayedFor(unit);
        const cell = cc.p(unit.x, unit.y);
        return {
            cells: [cell],
            highlight: !infoOpen && [cell],
            arrow: !infoOpen && cell,
            unitView: infoOpen && ["build"]
        };
    }
};